import React, { FunctionComponent } from 'react';
import { Header2, P1 } from 'components/typography';
import Icon, { IconSize } from 'components/icon/icon';

export type CheckListItemProps = {
    header: string;
    text: string;
};

const CheckListItem: FunctionComponent<CheckListItemProps> = ({ header, text }) => {
    return (
        <li className="check-list__item">
            <div className="check-list__item-icon">
                <Icon name="generic-action-yes" size={IconSize.STRETCH} />
            </div>
            <div className="check-list__item-content">
                <Header2>
                    <div className="check-list__item-header">{header}</div>
                </Header2>
                <P1>{text}</P1>
            </div>
        </li>
    );
};

export default CheckListItem;
